
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { getLiveCategorys, getLiveList, getmatchTeamList, getmatchTeamAdd, getmatchTeamDel } from '@/services/live';
import { message } from 'antd';
// 模拟团队数据
const teamsData = [
  // 足球队伍
  {
    id: 1,
    name: '曼彻斯特城',
    logo: 'https://readdy.ai/api/search-image?query=Manchester%20City%20football%20club%20logo%2C%20minimalist%20blue%20shield%20design%20with%20sky%20blue%20background%2C%20professional%20soccer%20team%20emblem%2C%20clean%20and%20modern%20sports%20logo%20design&width=120&height=120&seq=mancity-logo-1&orientation=squarish',
    sport: '足球',
    league: '英超联赛',
    country: '英格兰',
    founded: 1880,
    followers: 2850000,
    description: '英格兰足球超级联赛俱乐部，以攻势足球和技术足球著称',
    achievements: ['2021-22英超冠军', '2022-23欧冠冠军', '6次英超冠军'],
    stadium: '伊蒂哈德球场',
    capacity: 55000,
    manager: '瓜迪奥拉',
    colors: ['天蓝色', '白色']
  },
  {
    id: 2,
    name: '皇家马德里',
    logo: 'https://readdy.ai/api/search-image?query=Real%20Madrid%20football%20club%20logo%2C%20white%20royal%20crown%20design%2C%20elegant%20soccer%20team%20emblem%2C%20classic%20Spanish%20football%20club%20badge%20with%20white%20and%20gold%20colors&width=120&height=120&seq=realmadrid-logo-1&orientation=squarish',
    sport: '足球',
    league: '西甲联赛',
    country: '西班牙',
    founded: 1902,
    followers: 4200000,
    description: '西班牙足球甲级联赛豪门俱乐部，欧冠之王',
    achievements: ['14次欧冠冠军', '35次西甲冠军', '2022-23欧冠冠军'],
    stadium: '伯纳乌球场',
    capacity: 81044,
    manager: '安切洛蒂',
    colors: ['白色', '金色']
  },
  {
    id: 3,
    name: '巴塞罗那',
    logo: 'https://readdy.ai/api/search-image?query=FC%20Barcelona%20football%20club%20logo%2C%20blue%20and%20red%20stripes%20design%2C%20professional%20soccer%20team%20emblem%2C%20classic%20Catalan%20football%20club%20badge&width=120&height=120&seq=barcelona-logo-1&orientation=squarish',
    sport: '足球',
    league: '西甲联赛',
    country: '西班牙',
    founded: 1899,
    followers: 3900000,
    description: '加泰罗尼亚足球俱乐部，以tiki-taka战术闻名世界',
    achievements: ['5次欧冠冠军', '27次西甲冠军', '31次国王杯冠军'],
    stadium: '诺坎普球场',
    capacity: 99354,
    manager: '哈维',
    colors: ['蓝色', '红色']
  },
  // 篮球队伍
  {
    id: 4,
    name: '洛杉矶湖人',
    logo: 'https://readdy.ai/api/search-image?query=Los%20Angeles%20Lakers%20basketball%20team%20logo%2C%20purple%20and%20gold%20colors%2C%20professional%20NBA%20team%20emblem%2C%20clean%20design%2C%20modern%20basketball%20logo&width=120&height=120&seq=lakers-logo-1&orientation=squarish',
    sport: '篮球',
    league: 'NBA',
    country: '美国',
    founded: 1947,
    followers: 2100000,
    description: 'NBA历史最成功的球队之一，拥有众多传奇球星',
    achievements: ['17次NBA总冠军', '2020年NBA总冠军', '32次总决赛'],
    stadium: '加密货币中心',
    capacity: 20000,
    manager: '达文·哈姆',
    colors: ['紫色', '金色']
  },
  {
    id: 5,
    name: '金州勇士',
    logo: 'https://readdy.ai/api/search-image?query=Golden%20State%20Warriors%20basketball%20team%20logo%2C%20blue%20and%20yellow%20colors%2C%20professional%20NBA%20team%20emblem%2C%20modern%20basketball%20logo%20with%20warrior%20theme&width=120&height=120&seq=warriors-logo-1&orientation=squarish',
    sport: '篮球',
    league: 'NBA',
    country: '美国',
    founded: 1946,
    followers: 1850000,
    description: '以小球战术和三分球著称的NBA球队',
    achievements: ['7次NBA总冠军', '2022年NBA总冠军', '6次总决赛'],
    stadium: '大通中心',
    capacity: 18064,
    manager: '史蒂夫·科尔',
    colors: ['蓝色', '黄色']
  },
  {
    id: 6,
    name: '波士顿凯尔特人',
    logo: 'https://readdy.ai/api/search-image?query=Boston%20Celtics%20basketball%20team%20logo%2C%20green%20shamrock%20design%2C%20professional%20NBA%20team%20emblem%2C%20classic%20Celtic%20basketball%20logo%20with%20green%20colors&width=120&height=120&seq=celtics-logo-1&orientation=squarish',
    sport: '篮球',
    league: 'NBA',
    country: '美国',
    founded: 1946,
    followers: 1600000,
    description: 'NBA历史最悠久的球队之一，拥有丰富的冠军历史',
    achievements: ['17次NBA总冠军', '22次总决赛', '历史最多冠军'],
    stadium: 'TD花园球馆',
    capacity: 19156,
    manager: '乔·马祖拉',
    colors: ['绿色', '白色']
  },
  // 网球
  {
    id: 7,
    name: 'ATP巡回赛',
    logo: 'https://readdy.ai/api/search-image?query=ATP%20tennis%20tour%20logo%2C%20professional%20tennis%20association%20emblem%2C%20clean%20white%20and%20blue%20design%2C%20modern%20tennis%20tournament%20logo&width=120&height=120&seq=atp-logo-1&orientation=squarish',
    sport: '网球',
    league: 'ATP巡回赛',
    country: '国际',
    founded: 1972,
    followers: 890000,
    description: '世界男子职业网球协会，组织全球顶级网球赛事',
    achievements: ['大满贯赛事', '年终总决赛', '大师赛系列'],
    stadium: '全球各大球场',
    capacity: 0,
    manager: 'ATP委员会',
    colors: ['白色', '蓝色']
  },
  {
    id: 8,
    name: 'WTA巡回赛',
    logo: 'https://readdy.ai/api/search-image?query=WTA%20tennis%20tour%20logo%2C%20women%20tennis%20association%20emblem%2C%20professional%20female%20tennis%20logo%2C%20pink%20and%20white%20design&width=120&height=120&seq=wta-logo-1&orientation=squarish',
    sport: '网球',
    league: 'WTA巡回赛',
    country: '国际',
    founded: 1973,
    followers: 750000,
    description: '女子网球协会，推动女子职业网球发展',
    achievements: ['大满贯赛事', '年终总决赛', 'WTA1000系列'],
    stadium: '全球各大球场',
    capacity: 0,
    manager: 'WTA委员会',
    colors: ['粉色', '白色']
  },
  // 游泳
  {
    id: 9,
    name: '中国国家游泳队',
    logo: 'https://readdy.ai/api/search-image?query=China%20national%20swimming%20team%20logo%2C%20red%20and%20yellow%20colors%2C%20professional%20swimming%20team%20emblem%2C%20Chinese%20aquatic%20sports%20logo&width=120&height=120&seq=china-swim-logo-1&orientation=squarish',
    sport: '游泳',
    league: '国际泳联',
    country: '中国',
    founded: 1950,
    followers: 650000,
    description: '中国游泳运动的代表队，培养了众多世界冠军',
    achievements: ['多枚奥运金牌', '世锦赛冠军', '亚运会霸主'],
    stadium: '国家游泳中心',
    capacity: 17000,
    manager: '国家队教练组',
    colors: ['红色', '黄色']
  },
  {
    id: 10,
    name: '美国国家游泳队',
    logo: 'https://readdy.ai/api/search-image?query=USA%20national%20swimming%20team%20logo%2C%20red%20white%20and%20blue%20colors%2C%20american%20swimming%20team%20emblem%2C%20professional%20aquatic%20sports%20logo&width=120&height=120&seq=usa-swim-logo-1&orientation=squarish',
    sport: '游泳',
    league: '国际泳联',
    country: '美国',
    founded: 1920,
    followers: 580000,
    description: '世界游泳强国，培养了菲尔普斯等传奇泳将',
    achievements: ['奥运游泳霸主', '世锦赛常胜军', '多项世界纪录'],
    stadium: '各大游泳馆',
    capacity: 0,
    manager: '美国游泳协会',
    colors: ['红色', '白色', '蓝色']
  }
];

export default function Teams() {
  const navigate = useNavigate();
  const [selectedSport, setSelectedSport] = useState<{  id: number | null; name: string } | null>({ id: null,name: '全部' });
  const [selectedLeague, setSelectedLeague] = useState('全部');
  const [searchQuery, setSearchQuery] = useState('');
  const [followedTeams, setFollowedTeams] = useState<number[]>([1, 2, 4]); // 预设关注的队伍
  const [sortBy, setSortBy] = useState('followers'); // followers, name, founded
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(15);
  const [liveCategories, setLiveCategories] = useState<any[]>([]);
  const [teams, setTeams] = useState<any[]>([]); 
  
  // 获取所有运动类型和联赛
  const sports = ['全部', ...Array.from(new Set(teamsData.map(team => team.sport)))];
  const leagues = ['全部', ...Array.from(new Set(teamsData.map(team => team.league)))];

  // 注意：如果API支持排序和筛选，前端的这些逻辑可以简化或移除
  const filteredTeams = teams.filter(team => {
    const sportMatch = selectedSport.name === '全部' || team.sport === selectedSport.name;
    const leagueMatch = selectedLeague === '全部' || team.league === selectedLeague;
    const searchMatch =
      searchQuery === '' ||
      team.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      team.league.toLowerCase().includes(searchQuery.toLowerCase()) ||
      team.country.toLowerCase().includes(searchQuery.toLowerCase());
    return sportMatch && leagueMatch && searchMatch;
  });

  useEffect(() => {
    
        // 获取直播分类
        getLiveCategorys().then((res: any) => {
          if (res && res.status === 1 && Array.isArray(res.data)) {
            setLiveCategories([{ id: null, name: '全部' }, ...res.data]);
          }
        });
    
        
  
  }, []);
    useEffect(() => {
    // 获取队伍列表
    const params: any = {
      page: currentPage,
      page_size: itemsPerPage,
    };
    if (selectedSport.id) {
      params.live_id = selectedSport.id;
    }
    if (searchQuery) {
      params.keyword = searchQuery;
    }
    // 根据 sortBy 添加排序参数，如果API支持
    // params.sort = sortBy;

    getmatchTeamList(params).then((res: any) => {
      console.log('Fetched teams:', res.data.lists);
      if (res && res.status === 1 && Array.isArray(res.data.lists)) {
        setTeams(res.data.lists);
        console.log('Fetched teams:', res.data.lists);
      } else {
        setTeams([]); // 清空或显示错误
      }
    });
  }, [currentPage, itemsPerPage, selectedSport, searchQuery, sortBy]);
  // 排序队伍
  const sortedTeams = [...filteredTeams].sort((a, b) => {
    switch (sortBy) {
      case 'followers':
        return b.followers - a.followers;
      case 'name':
        return a.name.localeCompare(b.name);
      case 'founded':
        return b.founded - a.founded;
      default:
        return 0;
    }
  });

  // 分页
  const totalPages = Math.ceil(sortedTeams.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentTeams = sortedTeams.slice(startIndex, startIndex + itemsPerPage);

  // 格式化数字
  const formatNumber = (num: number) => {
    if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
    if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
    return num.toString();
  };

  // 处理关注/取消关注
  // 处理关注/取消关注
  const handleFollow = (teamId: number) => {
    const isFollowed = followedTeams.includes(teamId);
    const apiCall = isFollowed ? getmatchTeamDel : getmatchTeamAdd;

    apiCall({ id: String(teamId) }).then((res: any) => {
      if (res && res.status === 1) {
        setFollowedTeams(prev => {
          if (isFollowed) {
            return prev.filter(id => id !== teamId);
          } else {
            return [...prev, teamId];
          }
        });
        // Optimistically update follower count
        setTeams(currentTeams => currentTeams.map(t => {
          if (t.id === teamId) {
            return { ...t, number: isFollowed ? t.number - 1 : t.number + 1 };
          }
          return t;
        }));
      } else {
        message.success(res.info || '操作失败');
      }
    }).catch(error => {
        console.error("Follow/Unfollow error:", error);
        message.success(error.info || '操作失败');
    });
  };

  // 重置筛选条件
  const resetFilters = () => {
    setSelectedSport({ id: null, name: '全部' });
    setSelectedLeague('全部');
    setSearchQuery('');
    setSortBy('followers');
    setCurrentPage(1);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="py-6">
        <div className="container mx-auto px-4">
          {/* 返回按钮 */}
          <div className="mb-6">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center text-gray-600 hover:text-gray-800 transition-colors cursor-pointer group"
            >
              <i className="ri-arrow-left-line mr-2 text-lg group-hover:-translate-x-1 transition-transform"></i>
              <span className="text-sm font-medium">返回上一页</span>
            </button>
          </div>

          {/* 页面标题 */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">发现更多运动队伍</h1>
            <p className="text-gray-600 text-lg">
              关注你喜爱的体育队伍，第一时间获取赛事和资讯信息
            </p>
          </div>

          {/* 搜索和筛选 */}
          <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
            {/* 搜索框 */}
            <div className="mb-4">
              <div className="relative max-w-xl mx-auto">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i className="ri-search-line text-gray-400 text-sm"></i>
                </div>
                <input
                  type="text"
                  placeholder="搜索队伍名称、联赛、国家..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none text-sm"
                />
                {searchQuery && (
                  <button
                    onClick={() => {
                      setSearchQuery('');
                      setCurrentPage(1);
                    }}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                  >
                    <i className="ri-close-line text-gray-400 hover:text-gray-600 text-sm"></i>
                  </button>
                )}
              </div>
            </div>

            {/* 筛选选项 */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              {/* 运动类型 */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  <i className="ri-basketball-line mr-1"></i>
                  运动类型
                </label>
                <select
                  value={selectedSport?.name}
                  onChange={(e) => {
                    const selectedId = e.target.options[e.target.selectedIndex].getAttribute('data-id');
                    setSelectedSport({
                      id: selectedId ? parseInt(selectedId) : null,
                      name: e.target.value
                    });
                    setCurrentPage(1);
                  }}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none text-sm pr-8"
                >
                  {liveCategories.map(sport => (
                    <option key={sport.id || 'all'} value={sport.name} data-id={sport.id}>
                      {sport.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* 联赛 */}
              {/* <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  <i className="ri-trophy-line mr-1"></i>
                  联赛
                </label>
                <select
                  value={selectedLeague}
                  onChange={(e) => {
                    setSelectedLeague(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none text-sm pr-8"
                >
                  {leagues.map(league => (
                    <option key={league} value={league}>{league}</option>
                  ))}
                </select>
              </div> */}

              {/* 排序 */}
              {/* <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  <i className="ri-sort-desc mr-1"></i>
                  排序方式
                </label>
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none text-sm pr-8"
                >
                  <option value="followers">按关注人数</option>
                  <option value="name">按队伍名称</option>
                  <option value="founded">按成立时间</option>
                </select>
              </div> */}
            </div>

            {/* 筛选结果和重置 */}
            <div className="flex items-center justify-between">
              <div className="text-xs text-gray-600">
                找到 <span className="font-semibold text-green-600">{sortedTeams.length}</span> 支队伍
                {(selectedSport.name !== '全部' || selectedLeague !== '全部' || searchQuery) && (
                  <span className="ml-2">(已筛选)</span>
                )}
              </div>
              {(selectedSport.name !== '全部' || selectedLeague !== '全部' || searchQuery) && (
                <button
                  onClick={resetFilters}
                  className="text-xs text-green-600 hover:text-green-700 font-medium cursor-pointer"
                >
                  <i className="ri-refresh-line mr-1"></i>
                  重置筛选
                </button>
              )}
            </div>
          </div>

          {/* 队伍列表 */}
          {teams.length === 0 ? (
            <div className="text-center py-16">
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-search-line text-gray-400 text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">未找到相关队伍</h3>
              <p className="text-gray-500 mb-6">
                尝试调整搜索关键词或筛选条件
              </p>
              <Button onClick={resetFilters} variant="outline">
                <i className="ri-refresh-line mr-2"></i>
                重置搜索
              </Button>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
                {teams.map(team => (
                  <div
                    key={team.id}
                    className="bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden group border border-gray-100 hover:border-green-200"
                  >
                    {/* 队伍头部 - 精简化 */}
                    <div className="relative p-4 bg-gradient-to-br from-gray-50 to-gray-100">
                      <div className="text-center">
                        <img
                          src={team.logo}
                          alt={team.name}
                          className="w-16 h-16 mx-auto rounded-full object-cover shadow-lg mb-3 group-hover:scale-110 transition-transform duration-300"
                        />
                        <h3 className="font-bold text-base text-gray-900 mb-1 line-clamp-1">{team.name}</h3>
                        <div className="flex items-center justify-center space-x-2 mb-2">
                          <span className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded-full text-xs font-medium">
                            {team.category?.name}
                          </span>
                          <span className="text-gray-500 text-xs">{team?.country}</span>
                        </div>
                        <p className="text-xs font-medium text-gray-700 line-clamp-1">{team.league_name}</p>
                      </div>
                    </div>

                    {/* 队伍信息 - 大幅精简 */}
                    <div className="p-4">
                      <p className="text-gray-600 text-xs mb-3 line-clamp-2 h-8">
                        {team?.description}
                      </p>

                      {/* 统计信息 - 紧凑布局 */}
                      <div className="grid grid-cols-2 gap-3 mb-3">
                        <div className="text-center">
                          <div className="text-sm font-bold text-green-600">
                            {formatNumber(team.number)}
                          </div>
                          <div className="text-xs text-gray-500">关注者</div>
                        </div>
                        <div className="text-center">
                          <div className="text-sm font-bold text-gray-900">
                            {team.founded}
                          </div>
                          <div className="text-xs text-gray-500">成立</div>
                        </div>
                      </div>

                      {/* 主要成就 - 精简显示 */}
                     {team.achievements&& <div className="mb-3">
                        <div className="flex flex-wrap gap-1 justify-center">
                          {team.achievements.slice(0, 1).map((achievement, index) => (
                            <span
                              key={index}
                              className="px-2 py-0.5 bg-yellow-100 text-yellow-700 rounded text-xs line-clamp-1"
                            >
                              {achievement.length > 12 ? achievement.substring(0, 12) + '...' : achievement}
                            </span>
                          ))}
                          {team.achievements.length > 1 && (
                            <span className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded text-xs">
                              +{team.achievements.length - 1}
                            </span>
                          )}
                        </div>
                      </div>}

                      {/* 其他信息 - 只显示最重要的 */}
                     {team.manager&&  <div className="space-y-1 mb-3 text-xs text-gray-600">
                        <div className="flex items-center justify-center">
                          <i className="ri-user-line mr-1 text-gray-400"></i>
                          <span className="line-clamp-1">{team.manager}</span>
                        </div>
                        <div className="flex items-center justify-center">
                          <i className="ri-palette-line mr-1 text-gray-400"></i>
                          <span className="line-clamp-1">{team.colors.slice(0, 2).join('、')}</span>
                        </div>
                      </div>}

                      {/* 关注按钮 - 紧凑设计 */}
                      <Button
                        onClick={() => handleFollow(team.id)}
                        className={`w-full whitespace-nowrap cursor-pointer text-xs py-2 ${
                          followedTeams.includes(team.id)
                            ? 'bg-red-100 text-red-600 hover:bg-red-200 border-red-200'
                            : 'bg-green-500 text-white hover:bg-green-600'
                        }`}
                        variant={followedTeams.includes(team.id) ? 'outline' : 'primary'}
                      >
                        {followedTeams.includes(team.id) ? (
                          <>
                            <i className="ri-heart-fill mr-1"></i>
                            已关注
                          </>
                        ) : (
                          <>
                            <i className="ri-heart-line mr-1"></i>
                            关注
                          </>
                        )}
                      </Button>
                    </div>
                  </div>
                ))}
              </div>

              {/* 分页 */}
              {totalPages > 1 && (
                <div className="flex items-center justify-center space-x-2">
                  <button
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    className="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
                  >
                    <i className="ri-arrow-left-line mr-1"></i>
                    上一页
                  </button>

                  <div className="flex items-center space-x-1">
                    {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
                      let page;
                      if (totalPages <= 5) {
                        page = i + 1;
                      } else if (currentPage <= 3) {
                        page = i + 1;
                      } else if (currentPage >= totalPages - 2) {
                        page = totalPages - 4 + i;
                      } else {
                        page = currentPage - 2 + i;
                      }

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-2 rounded-lg cursor-pointer ${
                            currentPage === page
                              ? 'bg-green-500 text-white'
                              : 'border border-gray-300 text-gray-600 hover:bg-gray-50'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    })}
                  </div>

                  <button
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    className="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
                  >
                    下一页
                    <i className="ri-arrow-right-line ml-1"></i>
                  </button>
                </div>
              )}

              {/* 统计信息 */}
              <div className="text-center mt-6 text-sm text-gray-500">
                显示第 {startIndex + 1}-{Math.min(startIndex + itemsPerPage, sortedTeams.length)} 项，
                共 {sortedTeams.length} 支队伍
              </div>
            </>
          )}

          {/* 推荐关注 */}
          <div className="mt-12 bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-4">发现更多精彩</h3>
            <p className="text-green-100 mb-6">
              关注你喜爱的队伍，获取第一手赛事资讯和精彩瞬间
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Button
                variant="outline"
                className="bg-white text-green-600 hover:bg-gray-100 border-white whitespace-nowrap cursor-pointer"
              >
                <i className="ri-notification-line mr-2"></i>
                开启赛事提醒
              </Button>
              <Button
                variant="outline"
                className="bg-transparent text-white border-white hover:bg-white hover:text-green-600 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-community-line mr-2"></i>
                加入社区讨论
              </Button>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
